import Minze, { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'
import { Routing } from '../../modules/routing'
import { Locale } from '../../modules/locale'

export interface LvcProfileModalContent {}

export class LvcProfileModalContent extends MinzeElement {
  onReady(): void | Promise<void> {}

  userStateChanged = () => {
    MainModule.getInstance()
      .getRouting()
      .guardCurrentRoute(MainModule.getInstance().getAuth().isLoggedIn())
  }

  openProfileCulture = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profileCulture)
  }

  openProfileFavorites = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profileFavorites)
  }

  openProfilePersonal = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profilePersonal)
  }

  openProfileNotification = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profileNotification)
  }

  openProfileSecurity = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profileSecurity)
  }

  openUpdatePassword = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profileNotification)
  }

  handleLogout = () => {
    const mainModule = MainModule.getInstance()
    mainModule.getAuth().logout()
    //@TODO handle logout routing
    mainModule.hideModal(MODALS.PROFILE_MODAL)
  }

  html = () => `
    <div class="form">
      <lvc-box mt="24px">
        <lvc-button
          btn-preset="profile"
          theme="transparent" 
          id="btn-profile-culture"
        >
          <lvc-box display="flex" alignItems="center" justifyContent="start" columnGap="8px" color="#1E007D">
            <lvc-ticket-icon class="icon"></lvc-ticket-icon>
            <lvc-box width="100%" textAlign="left" display="flex" alignItems="center">
              ${Locale.getKey('profile.culture')}
            </lvc-box>
            <lvc-chevron-right-icon></lvc-chevron-right-icon>
          </lvc-box>
        </lvc-button>
        <lvc-button
          btn-preset="profile"
          id="btn-profile-favorites"
          theme="transparent"
        >
          <lvc-box display="flex" alignItems="center" justifyContent="start" columnGap="8px" color="#1E007D">
            <lvc-favorite-icon class="icon"></lvc-favorite-icon>
            <lvc-box width="100%" textAlign="left" display="flex" alignItems="center">
              ${Locale.getKey('profile.favorites')}
            </lvc-box>
            <lvc-chevron-right-icon></lvc-chevron-right-icon>
          </lvc-box>
        </lvc-button>
        <lvc-button
          btn-preset="profile"
          theme="transparent"
          id="btn-profile-security"
        >
          <lvc-box display="flex" alignItems="center" justifyContent="start" columnGap="8px" color="#1E007D">
            <lvc-key-icon class="icon"></lvc-key-icon>
            <lvc-box width="100%" textAlign="left" display="flex" alignItems="center">
              ${Locale.getKey('profile.security')}
            </lvc-box>
            <lvc-chevron-right-icon></lvc-chevron-right-icon>
          </lvc-box>
        </lvc-button>
        <lvc-button 
          btn-preset="profile"
          theme="transparent" 
          id="btn-profile-personal"
        >
          <lvc-box display="flex" alignItems="center" justifyContent="start" columnGap="8px" color="#1E007D">
              <lvc-person-icon class="icon"></lvc-person-icon>
              <lvc-box width="100%" textAlign="left" display="flex" alignItems="center">
                ${Locale.getKey('profile.personal')}
              </lvc-box>
              <lvc-chevron-right-icon></lvc-chevron-right-icon>
            </lvc-box>
        </lvc-button>
        <lvc-button 
          btn-preset="profileLastButton"
          theme="transparent" 
          id="btn-profile-notification"
        >
          <lvc-box display="flex" alignItems="center" justifyContent="start" columnGap="8px" color="#1E007D">
            <lvc-notification-icon class="icon"></lvc-notification-icon>
            <lvc-box width="100%" textAlign="left" display="flex" alignItems="center">
              ${Locale.getKey('profile.notification')}
            </lvc-box>
            <lvc-chevron-right-icon></lvc-chevron-right-icon>
          </lvc-box>
        </lvc-button>
        <lvc-box mt="24px">
          <lvc-button enable-hover-box-shadow="true" theme="dark" id="btn-logout">
            ${Locale.getKey('general.logout')}
          </lvc-button>
        </lvc-box>
      </lvc-box>


    
      
    </div>
  `

  css = () => `
    :host {
    }
    .icon {
      width: 32px;
      height: 32px;
    }
    @media screen and (max-width: 730px) {
      .button-wrapper {
        position: fixed;
        bottom: 73px;
        left: 0;
        right: 0;
        padding: 18px 16px;
        width: 100%;
        height: fit-content;
        max-width: calc(540px + 16*2px);
        margin: auto;
      }
    }
  `

  eventListeners: EventListeners = [
    ['#btn-profile-culture', 'click', this.openProfileCulture],
    ['#btn-profile-personal', 'click', this.openProfilePersonal],
    ['#btn-profile-notification', 'click', this.openProfileNotification],
    ['#btn-profile-favorites', 'click', this.openProfileFavorites],
    ['#btn-profile-security', 'click', this.openProfileSecurity],
    ['#btn-logout', 'click', this.handleLogout],
    [this, 'lvc:user_state_changed', this.userStateChanged],
  ]
}
